import {ValueObject} from '@s-ui/domain'

import DealerMappersFactory from '../../dealer/Mappers/factory.js'
import VehiclesEntitiesFactory from '../Entities/factory.js'

export class VehicleConfigurationValueObject extends ValueObject {
  #dealer
  #kmsFromDealerToZipcode
  #vehicle

  constructor({dealer, kmsFromDealerToZipcode, vehicle}) {
    super()
    this.#dealer = dealer
    this.#kmsFromDealerToZipcode = kmsFromDealerToZipcode
    this.#vehicle = vehicle
  }

  get dealer() {
    return this.#dealer.value
  }

  get kmsFromDealerToZipcode() {
    return this.#kmsFromDealerToZipcode
  }

  get vehicle() {
    return this.#vehicle.value
  }

  get value() {
    return {
      dealer: this.#dealer.value,
      kmsFromDealerToZipcode: this.#kmsFromDealerToZipcode,
      vehicle: this.#vehicle.value
    }
  }

  static createFromApi({config, data: apiData}) {
    const {dealer, vehicle: vehicleData} = apiData
    const {data, distance} = dealer
    const {horsePower, manufacturerPrice} = vehicleData.vehicle
    return new VehicleConfigurationValueObject({
      dealer: DealerMappersFactory.fromVehicleConfiguratorDealerRawDataToDealerEntityMapper({config}).map(data),
      kmsFromDealerToZipcode: parseFloat(distance.toFixed(1)),
      vehicle: VehiclesEntitiesFactory.vehicleEntity({
        ...vehicleData,
        ...vehicleData.vehicle,
        hp: horsePower,
        price: manufacturerPrice
      })
    })
  }
}
